// Determina l'environment del configuratore in base all'URL dello store.
// dmtcycling.com -> prod, dmtcycling-dev.myshopify.com (default) -> dev
function getConfiguratorEnvironment() {
  const host = window.location.hostname;
  return host === 'dmtcycling.com' || host === 'www.dmtcycling.com' ? 'production' : 'dev';
}

// Guida taglie: modal di snippets/product-size-chart.liquid, uno per prodotto (data-size-chart-product).
// In PDP e' gia' nel DOM, altrove (es. HP) viene scaricato da /products/<handle>?view=size-chart.
function getSizeChart(handle) {
  const sel = `[data-size-chart-product="${handle}"]`;
  return {
    overlay: document.querySelector(`[data-size-chart-overlay]${sel}`),
    modal: document.querySelector(`[data-size-chart-modal]${sel}`),
  };
}

async function openSizeChart(handle) {
  if (!handle) return;
  let { overlay, modal } = getSizeChart(handle);
  if (!modal) {
    try {
      const response = await fetch(`${window.Shopify.routes.root}products/${handle}?view=size-chart`);
      if (!response.ok) throw new Error(response.status);
      document.body.insertAdjacentHTML("beforeend", await response.text());
    } catch (error) {
      console.error("Size chart load failed:", error);
      return;
    }
    ({ overlay, modal } = getSizeChart(handle));
    if (!modal) return;
    modal.offsetWidth; // reflow: fa partire la transition anche al primo inserimento
  }
  // fuori da contenitori con transform/overflow; rimuovo copie duplicate (re-render varianti PDP)
  document.querySelectorAll(`[data-size-chart-product="${handle}"]`).forEach((el) => {
    if (el !== overlay && el !== modal) el.remove();
  });
  document.body.append(overlay, modal);
  overlay.classList.add("is-active");
  modal.classList.add("is-active");
  document.body.setAttribute("data-scroll-locked", "");
}

function closeSizeChart() {
  document
    .querySelectorAll("[data-size-chart-overlay].is-active, [data-size-chart-modal].is-active")
    .forEach((el) => el.classList.remove("is-active"));
  document.body.removeAttribute("data-scroll-locked");
}

document.addEventListener("click", (event) => {
  const openBtn = event.target.closest("[data-size-chart-open]");
  if (openBtn) {
    event.preventDefault();
    openSizeChart(openBtn.dataset.sizeChartOpen);
  } else if (event.target.closest("[data-size-chart-close], [data-size-chart-overlay]")) {
    event.preventDefault();
    closeSizeChart();
  }
});

// model_id -> handle prodotto reale (snippets/configurator.liquid)
const sizeChartMap = JSON.parse(document.getElementById("configurator-size-chart-map")?.textContent || "{}");

// la lib 3D emette onOpenSizeChart su #confiroot (senza bubbling)
document.getElementById("confiroot")?.addEventListener("onOpenSizeChart", (event) => {
  openSizeChart(event.currentTarget.dataset.sizeChartHandle);
});

class Configurator extends HTMLElement {
  constructor() {
    super();

    this.closeConfiguratorBtn = document.getElementById("close_configurator");
    this.html = document.getElementsByTagName("html")[0];
    this.configuratorWrapper = document.getElementById("configurator-wrapper");
    this.configurator = document.getElementById("confiroot");

    this.addEventListener("click", () => {
      // prendo i dataset che ho assegnato a product_configurator in template--product
      let productConfiguration = this.dataset.productConfiguration;
      const productSku = this.dataset.productSku;
      const productPrice = this.dataset.productPrice;
      const customizerVariantId = this.dataset.customizerVariantId;

      let productIndex = "";
      let productQuantity = "";

      if (productConfiguration !== "") {
        // Splitta la stringa basata su '|' per ottenere i diversi gruppi
        const pairs = productConfiguration.split('|').filter(Boolean);
        // Crea l'array materials escludendo 'taglia'
        const materials = pairs
          .map(pair => {
            // Splitta ogni coppia sulla base di ':'
            const [key, value] = pair.split(':');
            // Escludi il gruppo 'taglia'
            if (key.toLowerCase() === 'taglia') return null;
            // Restituisce l'oggetto formattato
            return {
              groupName: key.toUpperCase(),
              configuration: { name: value }
            };
          })
          .filter(Boolean); // Filtra fuori i valori nulli
        productConfiguration = materials;
        productIndex = this.dataset.productIndex;
        productQuantity = this.dataset.productQuantity;
      }

      // chiamo la funzione che apre il configuratore
      this.init(
        productSku,
        productPrice,
        productConfiguration,
        productIndex,
        productQuantity,
        customizerVariantId
      );
    });

    this.closeConfiguratorBtn.addEventListener("click", () => {
      this.onCloseConfigurator();
    });
  }

  init(
    productSku,
    productPrice,
    productConfiguration,
    productIndex,
    productQuantity,
    customizerVariantId,
    retryCount = 0
  ) {
    if (!window.ThreeDConfigurator) {
      if (retryCount < 20) {
        setTimeout(() => {
          this.init(productSku, productPrice, productConfiguration, productIndex, productQuantity, customizerVariantId, retryCount + 1);
        }, 500);
      } else {
        console.error("Configurator resources failed to load (timeout).");
        document.dispatchEvent(new CustomEvent("configuratorError", { detail: { reason: "timeout" } }));
      }
      return;
    }

    const allowedLangs = ["it", "fr", "es", "de", "en"];
    let language = document.getElementsByTagName("html")[0].lang;
    const langParam = new URLSearchParams(window.location.search).get("lang");
    if (langParam) {
      const normalizedLang = langParam.trim().toLowerCase();
      if (allowedLangs.includes(normalizedLang)) {
        language = normalizedLang;
      }
    }

    let data = {
      theme: "light",
      lang: language,
      price: productPrice,
    };

    if (productConfiguration !== "") {
      data.materials = productConfiguration;
    }

    data.b2c = {
      enableFlags: true,
      enableText: true
    };
    // inizializzo il configuratore 3D
    try {
      window.ThreeDConfigurator.init('confiroot', {
        ...data,
        modelId: this.dataset.productId,
        customProduct: this.dataset.customProduct || '',
        modelUrl: 'https://3dconfigurator.skillbill.net/api/',
        mode: 'b2c',
        client: 'dmt',
        environment: getConfiguratorEnvironment()
      });
    } catch (error) {
      console.error("Configurator init failed:", error);
      document.dispatchEvent(new CustomEvent("configuratorError", { detail: { reason: "init", error } }));
      return;
    }
    window.ThreeDConfigurator.elementId = 'confiroot';

    if (this.configurator._onPurchaseHandler) {
      this.configurator.removeEventListener(
        "onPurchase",
        this.configurator._onPurchaseHandler,
        false
      );
    }
    const onPurchaseHandler = (event) =>
      this.onPurchaseHandler(
        event,
        productIndex,
        productQuantity,
        productSku,
        customizerVariantId
      );
    this.configurator._onPurchaseHandler = onPurchaseHandler;
    this.configurator.addEventListener("onPurchase", onPurchaseHandler, false);

    // prodotto reale di cui mostrare la guida taglie (il prodotto customizer non ha taglie):
    // handle esplicito (PDP/card) o, altrove, dal metaobject configurator_model via model_id
    this.configurator.dataset.sizeChartHandle =
      this.dataset.sizeChartHandle || sizeChartMap[this.dataset.productId] || "";

    this.configuratorWrapper.classList.add("visible");

    // mostro l'icona per chiudere il configuratore
    this.closeConfiguratorBtn.classList.add("visible");

    // blocco lo scroll sulla pagina
    this.html.classList.add("configurator--visible")
  }

  onCloseConfigurator() {
    // rimuovo il listener onPurchase condiviso per evitare accumuli
    if (this.configurator._onPurchaseHandler) {
      this.configurator.removeEventListener(
        "onPurchase",
        this.configurator._onPurchaseHandler,
        false
      );
      this.configurator._onPurchaseHandler = null;
    }
    // chiudo il configuratore, nascondo l'icona e riattivo lo scroll
    window.ThreeDConfigurator.unmount();
    this.closeConfiguratorBtn.classList.remove("visible");
    this.html.classList.remove("configurator--visible")
    this.configuratorWrapper.classList.remove("visible");
  }

  async onPurchaseHandler(event, productIndex, productQuantity, productSku, customizerVariantId) {
    let formData, configurationCode, imagePath;
    var taglia = event.detail.size;

    configurationCode = taglia + "|";

    var properties = {};

    event.detail.configuration.map((el, index) => {
      var name = el.groupName.toLowerCase();
      if (name.includes(" ")) {
        var splitName = name.split(" ");
        name =
          splitName[0] +
          splitName[1].charAt(0).toUpperCase() +
          splitName[1].slice(1);
      }

      properties[name] = el.configuration.name;
      properties[`_${name}`] = el.code;
      configurationCode += el.code + "|";
    });

    properties.size = taglia;

    let codeFlag = "";
    let codeFlagOutline = "";
    let codeTextColor = "";
    let text = "";

    if (event.detail.details && event.detail.details[0]) {
      const detail = event.detail.details[0];
      if (detail.flag) {
        codeFlag = detail.flag;
        properties.flag = detail.flag;
        properties['_flag'] = detail.codeFlag;
      }
      if (detail.text) {
        text = detail.text;
        properties.text = detail.text;
        properties['_text'] = detail.codeTextColor;
      }
    }

    if (event.detail.flagOutlineColor && event.detail.flagOutlineColor.code) {
      codeFlagOutline = event.detail.flagOutlineColor.code;
      properties.flagOutlineColor = event.detail.flagOutlineColor.name;
      properties['_flagOutlineColor'] = event.detail.flagOutlineColor.code;
    }

    if (event.detail.textColor && event.detail.textColor.code) {
      codeTextColor = event.detail.textColor.code;
      properties.textColor = event.detail.textColor.name;
      properties['_textColor'] = event.detail.textColor.code;
    }

    configurationCode += `${codeFlag}${codeFlagOutline}|${codeTextColor}#${text}`;

    if (event.detail.details && Array.isArray(event.detail.details)) {
      const detail = event.detail.details[0];

      if (detail) {
        Object.entries(detail).forEach(([key, value]) => {
          properties[key] = value;
        });
      }
    }

    properties._configuration = configurationCode;
    properties._image = event.detail.image;
    // URL pubblico dell'immagine (S3, tramite l'App Proxy dell'app "DMT Configurator Image"): lo mostra il checkout.
    // Se il caricamento fallisce si aggiunge al carrello comunque, senza _imagePath.
    try {
      const res = await fetch("/apps/dmt-image", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ image: event.detail.image }),
        signal: AbortSignal.timeout(8000),
      });
      if (res.ok) properties._imagePath = (await res.json()).url;
    } catch (e) {}
    properties._Model_id = event.detail.modelId;
    properties._Configuration_code = event.detail.hubspotConfigurationId;

    if (productIndex !== "") {
      formData = {
        id: customizerVariantId,
        line: productIndex,
        quantity: productQuantity,
        properties,
      };
      this.updateProduct(formData);
    } else {
      formData = {
        items: [
          {
            id: customizerVariantId,
            quantity: 1,
            properties,
          },
        ],
      };

      this.addProduct(formData);
    }
  }

  addProduct(formData) {
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cart) {
      formData.sections = cart.getSectionsToRender().map((section) => section.id).join(',');
      formData.sections_url = window.location.pathname;
      cart.setActiveElement(document.activeElement);
    }

    fetch(`${routes.cart_add_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/javascript",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((response) => {
        // chiudo il configuratore, nascondo l'icona e riattivo lo scroll
        window.ThreeDConfigurator.unmount();
        this.closeConfiguratorBtn.classList.remove("visible");
        this.configuratorWrapper.classList.remove("visible");
        this.html.classList.remove("configurator--visible");

        if (response.status && response.status !== 200) {
          console.error("Cart error", response.message, response.description);
          return;
        }

        if (cart) {
          cart.renderContents(response);
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        } else {
          // dispatch evento per aprire il minicart fallback
          const event = new CustomEvent("minicart_configurated_product");
          document.dispatchEvent(event);
        }
      })
      .catch((error) => {
        // Fallback chiudi configuratore
        window.ThreeDConfigurator.unmount();
        this.closeConfiguratorBtn.classList.remove("visible");
        this.configuratorWrapper.classList.remove("visible");
        this.html.classList.remove("configurator--visible");
        console.error("Error:", error);
      });
  }

  updateProduct(formData) {
    fetch(`${routes.cart_update_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/javascript",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({
        line: formData.line,
        quantity: 0,
      }),
    })
      .then(() => {
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cart) {
          formData.sections = cart.getSectionsToRender().map((section) => section.id).join(',');
          formData.sections_url = window.location.pathname;
          cart.setActiveElement(document.activeElement);
        }

        fetch(`${routes.cart_add_url}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/javascript",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((response) => {
            // chiudo il configuratore, nascondo l'icona e riattivo lo scroll
            window.ThreeDConfigurator.unmount();
            this.closeConfiguratorBtn.classList.remove("visible");
            this.configuratorWrapper.classList.remove("visible");
            this.html.classList.remove("configurator--visible");

            if (response.status && response.status !== 200) {
              console.error("Cart error", response.message, response.description);
              return;
            }

            if (cart) {
              cart.renderContents(response);
              if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            } else {
              fetch(window.Shopify.routes.root + "cart/update.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/javascript",
                  "X-Requested-With": "XMLHttpRequest"
                },
                body: JSON.stringify({
                  id: formData.id,
                  quantity: formData.quantity,
                }),
              })
                .then(() => {
                  fetch("/cart?view=ajax", {
                    method: "GET",
                  }).then((resp) => {
                    resp.text().then((html) => {
                      const mainContent = document.querySelector(
                        ".main-content.page-main--wrapper"
                      );
                      if (mainContent) {
                        mainContent.innerHTML = html;
                      }
                    });
                  });
                })
                .catch((error) => {
                  console.error("Error:", error);
                });
            }
          })
          .catch((error) => {
            // Fallback chiudevide configurazione
            window.ThreeDConfigurator.unmount();
            this.closeConfiguratorBtn.classList.remove("visible");
            this.configuratorWrapper.classList.remove("visible");
            this.html.classList.remove("configurator--visible");
            console.error("Error:", error);
          });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

customElements.define("button-configurator", Configurator);